import { createSelector } from '@reduxjs/toolkit';
import { PrizeData, PrizeState } from '../types/prize.types';

interface RootState {
    prize: PrizeState;
}

export const selectPrizeState = (state: RootState) => state.prize;

export const selectPrizesLoading: (state: RootState) => boolean = createSelector(
    selectPrizeState,
    (prizeState): boolean => prizeState.loading
);

export const selectPrizesError: (state: RootState) => string | null = createSelector(
    selectPrizeState,
    (prizeState): string | null => prizeState.error
);

export const selectPrizesData: (state: RootState) => any = createSelector(
    selectPrizeState,
    (prizeState): any => prizeState.data
);

export const selectPrizesDataLoaded: (state: RootState) => any = createSelector(
    selectPrizeState,
    (prizeState): any => prizeState.loaded
);

export const selectWinnings: (state: RootState) => any[] = createSelector(
    selectPrizesData,
    (prizeData): any[] => prizeData?.winnings || []
);

export const selectPrizesTaxVerified: (state: RootState) => any = createSelector(
    selectPrizesData,
    (prizeData: PrizeData): boolean => prizeData?.identityTaxVerified
);

export const selectPrizesOffline: (state: RootState) => boolean = createSelector(
    selectPrizeState,
    (prizeState): boolean => Boolean(prizeState.data?.offlinePayment)
);
